import { getDefaultConfig } from '@guiker/shared-framework'

export const config = {
  ...getDefaultConfig('rent-payment'),
}
